export default __webpack_public_path__ + "static/media/mouse_pad.66b2cfe3.jpg";